import React from "react";
import { SimpleForm, TextInput } from "react-admin";
import { Card, CardContent, Grid } from "@mui/material";
import { RichTextInput } from "ra-input-rich-text";

const EquipmentEditForm: React.FC<EditFormProps> = ({ type }) => {

    return (
        <SimpleForm mode="onBlur" reValidateMode="onBlur">
            <Card sx={{ width: "100%" }}>
                <CardContent sx={{ width: "100%" }}>
                    <Grid container spacing={{ xs: 0, sm: 0, md: 2 }}>
                        {type === 'edit' && (
                            <Grid item xs={12} sm={12} md={4}>
                                <TextInput name="recordId"
                                           source="recordId"
                                           label="Record ID"
                                           fullWidth
                                           variant="filled"
                                           disabled
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} sm={12} md={4}>
                            <TextInput name="name"
                                       source="name"
                                       label="Name"
                                       fullWidth
                                       variant="filled"
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={4}>
                            <TextInput name="nameZhHk"
                                       source="nameZhHk"
                                       label="Name (ZH-HK)"
                                       fullWidth
                                       variant="filled"
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                            <RichTextInput name="description"
                                           source="description"
                                           label="Description"
                                           fullWidth
                                           minHeight={400}
                                           sx={{
                                               "& .tiptap": {
                                                   minHeight: 400,
                                               },
                                           }}
                            />
                        </Grid>

                    </Grid>
                </CardContent>
            </Card>
        </SimpleForm>
    );
};

export default EquipmentEditForm;
